/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useLocale } from "@i18n/react";
import { toLocaleUTCDateString } from "@packages/sdk";

import { Text } from "../../../_base/_core/Text/Text.emotion";

const dateWrapperStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

type StackedDate = {
  date?: Date;
  month?: string;
  day?: string;
};

export const StackedDate = ({
  date = new Date(),
  month = "short",
  day = "numeric",
}: StackedDate) => {
  const locale = useLocale();

  const localeDate = toLocaleUTCDateString(date, locale, {
    month,
    day,
  });

  const dateWords = localeDate.split(" ");
  const dateMonth = (
    <Text type="title" size="xs">
      {dateWords[0]}
    </Text>
  );
  const dateDay = (
    <Text type="title" size="s">
      {dateWords[1]}
    </Text>
  );

  return (
    <span css={dateWrapperStyle}>
      {dateMonth}
      {dateDay}
    </span>
  );
};
